<template>
  <textarea :value="value" @input="autoResize" @change="handleChange" ref="autoTextarea"
    :style="{ overflow: 'hidden', resize: 'none' }" rows="4"></textarea>
</template>

<script>
export default {
  name: "AutoResizeTextarea",
  props: {
    value: {
      type: String,
      required: true
    },
    qid: {
      type: [Number, String]
    },
    cid: {
      type: [Number, String]
    },
    rid: {
      type: [Number, String]
    }
  },
  data() {
    return {
      minRows: 4
    };
  },
  watch: {
    value() {
      this.autoResize();
    }
  },
  methods: {
    handleChange(event) {
      const newVal = event.target.value;
      if (newVal === this.value) return;

      if (this.qid !== undefined)
        this.$emit("answerChanged", this.qid, newVal);
      else if (this.cid !== undefined && this.rid !== undefined)
        this.$emit("answerChanged", this.rid, this.cid, newVal);
      else
        console.error("No question id or cell id and row id provided");
    },
    autoResize() {
      const textarea = this.$refs.autoTextarea;
      textarea.style.height = "auto";

      const lineHeight = parseFloat(window.getComputedStyle(textarea).lineHeight);
      const minHeight = lineHeight * this.minRows;

      textarea.style.height = `${Math.max(textarea.scrollHeight, minHeight)}px`;
    },
    resizeToFit() {
      this.autoResize();
    }
  },
  mounted() {
    this.autoResize();
  }
};
</script>